import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isReviewNpcEntry: false, loading: false };

export const reviewNpcEntryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.REVIEW_NPC_ENTRY_SUCCESS:
      return { ...state, isReviewNpcEntry: true, response: action.payload, loading: false };
    case npcLogConstant.REVIEW_NPC_ENTRY_FAILURE:
      return { ...state, isReviewNpcEntry: false, response: action.payload, loading: false };
    case npcLogConstant.REVIEW_NPC_ENTRY_LOADER:
      return { ...state, loading: true };
    case npcLogConstant.REVIEW_NPC_ENTRY_RESET:
      return initialState;
    default:
      return state;
  }
};
